{
  "organization.status.active": "Aktivní",
  "organization.status.disabled": "Pozastavený",
  "organization.status.pending": "Čeká na aktivaci",
  "eventTypes.title": "Typy akcí",
  "eventTypes.intro": "Nastavte vlastní typy akcí. Výchozí hodnoty potvrdíte při vytvoření konkrétní akce.",
  "eventTypes.empty": "Zatím nemáte typ akce. Vytvořte jej před založením první akce.",
  "eventTypes.error": "Nastavení se nepodařilo uložit nebo načíst. Zkontrolujte výsledek před opakováním.",
  "eventTypes.saved": "Typ akce byl uložen.",
  "eventTypes.new": "Nový typ",
  "eventTypes.settings": "Nastavení typu akce",
  "eventTypes.code": "Jedinečný kód (bez mezer)",
  "eventTypes.cs": "Český název",
  "eventTypes.en": "Anglický název",
  "eventTypes.mode": "Způsob přihlašování",
  "eventTypes.mode.self_service": "Účastník se přihlašuje sám",
  "eventTypes.mode.admin_only": "Účastníky přidává správce",
  "eventTypes.mode.mixed": "Účastník i správce",
  "eventTypes.capacity": "Výchozí kapacita (prázdná = bez omezení)",
  "eventTypes.enrollment": "Podporuje přihlášení účastníků",
  "eventTypes.waitlist": "Výchozí povolení čekací listiny",
  "eventTypes.status": "Dostupnost typu",
  "eventTypes.status.active": "Aktivní",
  "eventTypes.status.archived": "Archivovaný",
  "organization.title": "Vaše organizace",
  "organization.intro": "Vyberte organizaci, ve které chcete pracovat. Přístup určuje její správce.",
  "organization.empty": "Zatím nejste členem žádné organizace.",
  "organization.create": "Založit organizaci",
  "organization.name": "Název organizace",
  "organization.ownerNote": "Stanete se vlastníkem a správcem této organizace, nikoli správcem platformy.",
  "organization.closed": "Zakládání organizací je v uzavřeném pilotu povoleno jen schváleným účtům.",
  "organization.error": "Akci nelze dokončit. Znovu načtěte účet nebo kontaktujte správce. Před opakováním založení organizace zkontrolujte výsledek.",
  "organization.members": "Členové organizace",
  "organization.subject": "ID uživatele z Keycloaku",
  "organization.subjectHelp": "Použijte přesné ID ručně vytvořeného účtu, ne e-mail. Přístup začne fungovat po přihlášení tohoto účtu.",
  "organization.roles": "Oprávnění podle rolí",
  "organization.active": "Přístup povolen",
  "organization.owner": "Vlastník",
  "organization.ownerProtected": "Přístup vlastníka a vlastní přístup zde nelze měnit. Převod vlastnictví není součástí pilotu.",
  "organization.saved": "Členství bylo uloženo.",
  "organization.readOnly": "Máte pouze přístup pro čtení.",
  "app.name": "Event",
  "app.tagline": "Platforma pro správu událostí",
  "common.loading": "Načítání…",
  "common.error": "Došlo k chybě.",
  "common.retry": "Zkusit znovu",
  "common.cancel": "Zrušit",
  "common.confirm": "Potvrdit",
  "common.save": "Uložit",
  "common.back": "Zpět",
  "common.edit": "Upravit",
  "common.delete": "Smazat",
  "common.create": "Vytvořit",
  "common.empty": "Žádné záznamy.",
  "common.yes": "Ano",
  "common.no": "Ne",
  "common.notSignedIn": "Pro tuto akci se musíte přihlásit.",
  "common.signInHint": "Pokračujte přes přihlášení.",
  "auth.signIn": "Přihlásit se",
  "auth.signOut": "Odhlásit se",
  "auth.greeting": "Vítej, {name}.",
  "auth.unauthorized": "Pro tuto akci je nutné přihlášení.",
  "auth.forbidden": "Pro tuto akci nemáte oprávnění.",
  "auth.loadingTitle": "Ověřuji přístup",
  "locale.cs": "Čeština",
  "locale.en": "Angličtina",
  "tenant.default": "eDO",
  "tenant.label": "Organizace",
  "tenant.current": "Aktivní organizace",
  "session.label": "Přihlášený uživatel",
  "session.none": "Nepřihlášen",
  "session.devHint": "Demo přístup slouží jen pro ověřování rolí mimo produkční přihlášení.",
  "session.signOut": "Odhlásit",
  "role.attendee": "Účastník",
  "role.attendee.description": "Přihlašuje se k událostem a plní úkoly.",
  "role.manager": "Manažer",
  "role.manager.description": "Sleduje účast a reporty svého týmu.",
  "role.organizer": "Organizátor",
  "role.organizer.description": "Spravuje průběh události a prezenci.",
  "role.event_admin": "Administrátor událostí",
  "role.event_admin.description": "Spravuje katalog událostí a publikace.",
  "role.hr": "Personalista",
  "role.hr.description": "Přístup k reportům napříč organizací.",
  "role.reviewer": "Hodnotitel",
  "role.reviewer.description": "Kontroluje a hodnotí úkoly účastníků.",
  "role.sys_admin": "Systémový administrátor",
  "role.sys_admin.description": "Správa identity, nastavení a provozních ploch organizace.",
  "role.auditor": "Auditor",
  "role.privacy_officer": "Pověřená osoba pro zpracování údajů",
  "role.privacy_officer.description": "Připravuje a schvaluje pravidla zpracování údajů organizace; nejde o automatické jmenování DPO.",
  "role.auditor.description": "Auditní přístup pouze ke čtení.",
  "role.platform_admin": "Platformní administrátor",
  "role.platform_admin.description": "Správa organizací a platformního provozu.",
  "nav.attendee": "Pro účastníky",
  "nav.admin": "Administrace",
  "nav.platform": "Platforma",
  "nav.workspaces": "Pracovní prostory",
  "nav.continue": "Pokračovat do aplikace",
  "nav.overview": "Přehled",
  "nav.tenants": "Organizace",
  "nav.openWorkspace": "Otevřít",
  "nav.localeSwitch": "Jazyk",
  "nav.events": "Události",
  "nav.identity": "Identita",
  "nav.enrollments": "Moje přihlášky",
  "nav.scanner": "Skener",
  "landing.eyebrow": "Eventová aplikace",
  "landing.headline": "{app}: přihlášky, docházka a úkoly přehledně",
  "landing.subheadline": "Jedno místo pro účastníky, organizátory i správce. Po přihlášení aplikace otevře správnou plochu podle vaší role.",
  "landing.cta.secondary": "Zobrazit možnosti přihlášení",
  "landing.sectionsLabel": "Přehled pracovních prostorů",
  "landing.section.attendee.title": "Pro zaměstnance a účastníky",
  "landing.section.attendee.body": "Účastník vidí dostupné akce, své přihlášky, vstupní QR kód a úkoly k dokončení.",
  "landing.section.admin.title": "Pro organizátory a administrátory akcí",
  "landing.section.admin.body": "Správa termínů, kapacit, prezence, hodnocení a reportů na jednom místě.",
  "landing.section.platform.title": "Pro správu platformy",
  "landing.section.platform.body": "Oddělená plocha pro správu organizací, stavů a základních provozních pravidel.",
  "landing.note.title": "Jak funguje přístup",
  "landing.note.body": "Aplikace po přihlášení zobrazí jen ty části, které odpovídají roli uživatele a jeho organizaci.",
  "landing.note.identity": "Pracovní prostory účastníka, organizátora, administrátora a správce platformy zůstávají oddělené. Přihlášení samo o sobě neuděluje oprávnění k událostem organizace.",
  "landing.story.kicker": "Přehledný průběh akce",
  "landing.story.title": "Klidná kontrola nad průběhem událostí",
  "landing.story.body": "Od registrace přes prezenci až po vyhodnocení má každý uživatel jasný další krok.",
  "landing.story.metricAttendance": "Důvěra v docházku",
  "landing.story.metricHandoff": "Sledovaná předání",
  "landing.backHome": "Zpět na úvod",
  "home.headline": "Vítejte na platformě {app}",
  "home.subheadline": "Toto je bootstrap verze klientského rozhraní. Obsah jednotlivých modulů se doplní v dalších vlnách.",
  "home.cta.attendee": "Vstoupit jako účastník",
  "home.cta.admin": "Přejít do administrace",
  "signin.title": "Přihlášení",
  "signin.compact.intro": "Přihlaste se a pokračujte do svého pracovního prostoru.",
  "signin.compact.organizationTitle": "Vítejte zpět",
  "signin.compact.organizationIntro": "Přihlaste se svým účtem a pokračujte do organizace {organization}.",
  "signin.compact.organizationBack": "Zpět na stránku organizace",
  "signin.intro": "Přihlaste se účtem pro tuto službu. Aplikace vám otevře pracovní prostor podle vašich oprávnění.",
  "signin.help.title": "Nevíte, kam budete přesměrováni?",
  "signin.help.label": "Nápověda k přihlášení",
  "signin.help.body": "Cílová plocha se neurčuje ručně. Aplikace ji vybere podle přístupu, který máte pro svou organizaci.",
  "signin.fact.account.label": "Účet",
  "signin.fact.account.value": "Zabezpečené přihlášení",
  "signin.fact.workspace.label": "Plocha",
  "signin.fact.workspace.value": "Podle role",
  "signin.fact.language.label": "Jazyk",
  "signin.fact.language.value": "Česky i anglicky",
  "signin.back": "Zpět na možnosti přihlášení",
  "signin.environment": "Prostředí",
  "signin.appEnv.local": "Lokální",
  "signin.appEnv.pilot": "Pilot",
  "signin.appEnv.production": "Produkce",
  "signin.posture.label": "Postoj",
  "signin.posture.local_development.title": "Lokální ověřování",
  "signin.posture.local_development.body": "Toto prostředí slouží pro interní ověřování a nesmí být zaměňováno za produkční přístup.",
  "signin.posture.pilot_rehearsal.title": "Pilotní ověřování",
  "signin.posture.pilot_rehearsal.body": "Toto prostředí je určeno pro pilot a demo. Finální pravidla produkčního přihlášení zůstávají samostatným rozhodnutím.",
  "signin.posture.production_external_identity.title": "Externí správa účtů",
  "signin.posture.production_external_identity.body": "Přihlášení používá externí správu účtů bez demo přístupu.",
  "signin.mode.mock_oidc": "Demo přístup",
  "signin.mode.external_oidc": "Zabezpečené přihlášení",
  "signin.sso.badge": "Doporučený vstup",
  "signin.sso.title": "Zabezpečené přihlášení",
  "signin.sso.body": "Pokračujte přes správu účtů této služby. Přístup k událostem určuje vaše členství v organizaci a přidělená oprávnění.",
  "signin.sso.posture.local_development": "Pro interní ověřování se může používat bezpečně oddělená demo cesta.",
  "signin.sso.posture.pilot_rehearsal": "Pro pilot se používá schválená přihlašovací cesta daného prostředí.",
  "signin.sso.posture.production_external_identity": "Přihlášení používá nastaveného poskytovatele identity.",
  "signin.sso.cta": "Pokračovat k přihlášení",
  "signin.sso.notConfigured": "Přihlášení ještě není v tomto prostředí dokončené. Kontaktujte správce aplikace.",
  "signin.sso.localMode": "Toto prostředí používá demo přihlášení pro ověření rolí a průchodů.",
  "signin.readiness.label": "Připravenost",
  "signin.readiness.productionSafe": "Produkční konfigurace bez demo přístupu",
  "signin.readiness.nonProduction": "Pilotní režim",
  "signin.readiness.browserConfigured": "Přihlášení nastaveno",
  "signin.readiness.browserMissing": "Přihlášení není dokončené",
  "signin.dev.badge": "Pilotní demo",
  "signin.dev.badgeDisabled": "V tomto prostředí vypnuto",
  "signin.dev.title": "Demo přístup",
  "signin.dev.body": "Použijte připravený demo účet pro ověření jednotlivých rolí a pracovních ploch.",
  "signin.dev.posture.local_development": "Demo účty pomáhají rychle ověřit průchody bez produkčního přihlášení.",
  "signin.dev.posture.pilot_rehearsal": "Demo přístup držte jen pro řízené pilotní ukázky.",
  "signin.dev.posture.production_external_identity": "V produkci má být demo přístup vypnutý.",
  "signin.dev.cta": "Vybrat demo účet",
  "signin.dev.unavailable": "Demo přístup není v tomto prostředí zapnutý.",
  "signin.dev.detail": "Vyberte připravený demo účet. Aplikace po přihlášení sama nastaví odpovídající organizaci a role.",
  "signin.dev.empty": "Nejsou dostupné žádné demo účty.",
  "signin.dev.subjectLabel": "Demo účet",
  "signin.dev.locale": "Preferovaný jazyk: {locale}",
  "signin.dev.submit": "Přihlásit tímto účtem",
  "signin.callback.title": "Dokončuji přihlášení",
  "signin.callback.failedTitle": "Přihlášení nebylo dokončeno",
  "signin.callback.body": "Zpracovávám návrat z externího přihlášení a vytvářím session pro webovou aplikaci.",
  "signin.oidc.failed": "Přihlášení se nepodařilo dokončit. Zkuste se přihlásit znovu. Pokud problém trvá, kontaktujte správce.",
  "signin.oidc.expired": "Přihlášení vypršelo nebo ho nelze bezpečně obnovit. Přihlaste se prosím znovu.",
  "signin.story.kicker": "Po přihlášení",
  "signin.story.title": "Identita se promítne do správného pracovního prostoru",
  "signin.story.body": "Účastník, organizátor i správce platformy vidí oddělené a srozumitelné části aplikace.",
  "signin.story.metricRoles": "Směrování podle rolí",
  "signin.story.metricTenant": "Organizace ze session",
  "signin.story.metricAttendeeValue": "Moje akce",
  "signin.story.metricAttendee": "Přihlášky, QR kód a úkoly.",
  "signin.story.metricAdminValue": "Správa",
  "signin.story.metricAdmin": "Akce, prezence, hodnocení a reporty.",
  "signin.story.metricPlatformValue": "Platforma",
  "signin.story.metricPlatform": "Oddělená správa organizací.",
  "signin.story.rowAccount": "Přihlášení potvrdí uživatele a otevře dostupné role.",
  "signin.story.rowWorkspace": "Role a organizace určují cílovou plochu po přihlášení.",
  "signin.story.rowLanguage": "Rozhraní je připravené v češtině i angličtině.",
  "attendee.title": "Prostor pro účastníky",
  "attendee.intro": "Zde se objeví události, vaše přihlášky a docházka.",
  "attendee.context": "Přihlášeno jako {user} pro organizaci {tenant}.",
  "attendee.story.kicker": "Vedený pracovní prostor",
  "attendee.story.title": "Další kroky zůstávají viditelné",
  "attendee.story.body": "Publikované události, stav registrace i přidělená práce zůstávají v jednom klidném a vedeném pohledu.",
  "attendee.story.rowEvent": "Nejbližší publikovaná událost",
  "attendee.story.rowEventMeta": "Termín registrace, místo i přístup zůstávají snadno čitelné.",
  "attendee.story.rowTask": "Otevřená práce účastníka",
  "attendee.story.rowTaskMeta": "Uploady, vrácení i review zůstávají viditelné bez dalšího hledání.",
  "attendee.events.title": "Nabídka událostí",
  "attendee.events.empty": "Momentálně nejsou vypsané žádné události.",
  "attendee.events.emptyBody": "Jakmile organizátor publikuje novou akci, zobrazí se zde s termínem, místem a možností přihlášení.",
  "attendee.events.detailCta": "Detail události",
  "attendee.home.eventsBody": "Projděte si publikované události, termíny přihlášení a připravte se před registrací.",
  "attendee.home.enrollmentsBody": "Sledujte aktivní registrace, čekací listiny i vstupní kódy ke svým akcím na jednom místě.",
  "attendee.home.tasksBody": "Vraťte se k přiřazeným úlohám, uploadům a odevzdáním, která ještě čekají na vaši akci.",
  "attendee.enrollments.title": "Moje přihlášky",
  "attendee.enrollments.empty": "Zatím nemáte žádnou přihlášku.",
  "attendee.enrollments.emptyBody": "Vyberte si akci v nabídce událostí. Po přihlášení zde uvidíte stav registrace a vstupní QR kód.",
  "attendee.enrollments.status.registered": "Přihlášeno",
  "attendee.enrollments.status.waitlisted": "Čekací listina ({position})",
  "attendee.enrollments.status.cancelled": "Zrušeno",
  "attendee.enrollments.cancel": "Zrušit přihlášku",
  "attendee.enrollments.cancelConfirm": "Opravdu chcete přihlášku zrušit?",
  "attendee.enrollments.showQr": "Zobrazit QR kód",
  "attendee.enrollments.tokenHeadline": "Váš vstupní kód",
  "attendee.enrollments.tokenHint": "Kód předložte organizátorovi na události.",
  "attendee.enrollments.tokenExpiresAt": "Platnost do {date}",
  "attendee.enrollments.tokenExpiresLabel": "Platnost",
  "attendee.enrollments.tokenJtiLabel": "ID kódu",
  "attendee.enrollments.tokenJti": "ID kódu: {jti}",
  "attendee.enrollments.qrLabel": "Skenovatelný QR kód pro vstup na událost",
  "attendee.enrollments.tokenFallback": "Pokud skenování není k dispozici, organizátor může použít technický token níže.",
  "attendee.enrollments.tokenDetails": "Zobrazit technický token",
  "attendee.enrollments.summary.waitlisted": "Čekací listina",
  "attendee.enroll.cta": "Přihlásit se",
  "attendee.enroll.full": "Kapacita vyčerpána",
  "attendee.enroll.waitlist": "Zařadit na čekací listinu",
  "attendee.enroll.closed": "Přihlášky nejsou otevřené.",
  "attendee.enroll.success.registered": "Úspěšně přihlášeno.",
  "attendee.enroll.success.waitlisted": "Jste na čekací listině.",
  "event.state.draft": "Koncept",
  "event.state.published": "Publikováno",
  "event.state.registration_open": "Otevřeno k přihlášení",
  "event.state.in_progress": "Probíhá",
  "event.state.completed": "Ukončeno",
  "event.state.archived": "Archivováno",
  "event.capacity.label": "Kapacita",
  "event.capacity.unlimited": "Neomezeno",
  "event.capacity.remaining": "Volných míst: {remaining} / {capacity}",
  "event.capacity.full": "Plná kapacita",
  "event.startsAt": "Začátek",
  "event.endsAt": "Konec",
  "event.registrationWindow": "Přihlašování",
  "event.location": "Místo konání",
  "event.type": "Typ události",
  "admin.title": "Správa akcí",
  "admin.intro": "Pracovní plocha zobrazuje jen části, které odpovídají vašim rolím a oprávněním.",
  "admin.story.kicker": "Provozní command",
  "admin.story.title": "Provozní připravenost na první pohled",
  "admin.story.body": "Životní cyklus událostí, skenování na místě, review i reporting zůstávají sladěné v jednom řízeném pracovním prostoru.",
  "admin.story.metricScanner": "Pulse během akce",
  "admin.story.rowLifecycle": "Řízení životního cyklu",
  "admin.story.rowLifecycleMeta": "Publikace, registrace i dokončení zůstávají dohledatelné.",
  "admin.story.rowScanner": "Operace nad docházkou",
  "admin.story.rowScannerMeta": "Sběr na místě zůstává odolný i při výpadku sítě.",
  "admin.story.rowReporting": "Reporting a exporty",
  "admin.story.rowReportingMeta": "Completion i handoff signály zůstávají explicitní i pro stakeholdery.",
  "admin.workspace.events": "Katalog a detail událostí, včetně změn stavu a správy kapacit.",
  "admin.workspace.scanner": "Organizátorský provoz na místě akce včetně offline fronty a check-in toku.",
  "admin.workspace.reviews": "Fronta hodnocení a rozhodování nad odevzdanými úlohami účastníků.",
  "admin.workspace.reporting": "Reporty, exporty a navazující přehledy dostupné podle oprávnění.",
  "admin.workspace.identity": "Role, mapování skupin a přehled efektivních přístupů pro organizaci.",
  "admin.events.title": "Katalog událostí",
  "admin.events.newCta": "Nová událost",
  "admin.events.empty": "Ještě nejsou vytvořené žádné události.",
  "admin.events.emptyBody": "Začněte vytvořením termínu. Účastníci ho uvidí až po publikaci a otevření přihlášek.",
  "admin.events.transitionTo": "Přechod do stavu",
  "admin.events.create.title": "Nová událost",
  "admin.events.create.cta": "Vytvořit událost",
  "admin.events.form.eventType": "Typ události",
  "admin.events.form.code": "Kód",
  "admin.events.form.section.basics": "Základní nastavení události",
  "admin.events.form.section.copy": "Texty pro účastníky",
  "admin.events.form.section.schedule": "Termíny a registrace",
  "admin.events.form.section.capacity": "Kapacita a čekací listina",
  "admin.events.form.section.location": "Místo a časové pásmo",
  "admin.events.form.help.basics.label": "Nápověda k základnímu nastavení",
  "admin.events.form.help.basics.body": "Typ události určuje výchozí pravidla a texty. Kód držte krátký a srozumitelný pro organizátory.",
  "admin.events.form.help.copy.label": "Nápověda k textům pro účastníky",
  "admin.events.form.help.copy.body": "Český název je povinný. Anglický název a popis vyplňte, pokud má být akce srozumitelná i v anglickém rozhraní.",
  "admin.events.form.help.schedule.label": "Nápověda k termínům",
  "admin.events.form.help.schedule.body": "Termín akce a přihlašovací okno mohou být odlišné. Přihlášky se zobrazují účastníkům podle aktuálního stavu akce.",
  "admin.events.form.help.capacity.label": "Nápověda ke kapacitě",
  "admin.events.form.help.capacity.body": "Kapacita omezuje počet potvrzených účastníků. Čekací listina umožní evidovat další zájemce bez přeplnění akce.",
  "admin.events.form.titleCs": "Název (česky)",
  "admin.events.form.titleEn": "Název (anglicky)",
  "admin.events.form.summaryCs": "Krátký popis (česky)",
  "admin.events.form.summaryEn": "Krátký popis (anglicky)",
  "admin.events.form.capacity": "Kapacita",
  "admin.events.form.waitlistEnabled": "Povolit čekací listinu",
  "admin.events.form.startsAt": "Začátek",
  "admin.events.form.endsAt": "Konec",
  "admin.events.form.registrationOpensAt": "Přihlašování otevřeno",
  "admin.events.form.registrationClosesAt": "Přihlašování uzavřeno",
  "admin.events.form.timezone": "Časové pásmo",
  "admin.events.form.locationName": "Název místa",
  "admin.events.form.locationAddress": "Adresa",
  "admin.events.enrollments.title": "Přihlášky ({count})",
  "admin.events.enrollments.waitlisted": "Čekací listina: {count}",
  "admin.events.enrollments.empty": "Zatím žádné přihlášky.",
  "admin.events.enrollments.columnUser": "Uživatel",
  "admin.events.enrollments.columnStatus": "Stav",
  "admin.events.enrollments.columnSource": "Zdroj",
  "admin.events.enrollments.columnRegisteredAt": "Registrováno",
  "events.story.kicker": "Event command",
  "events.story.title": "Správná hustota signálů pro řízení události",
  "events.story.body": "Životní cyklus, docházková politika i aktivita registrací zůstávají čitelné bez ztráty provozního detailu.",
  "events.story.metricEnrollment": "Aktivní registrace",
  "events.story.metricWaitlist": "Tlak na čekací listinu",
  "events.story.metricPolicy": "Aktuální zdroj politiky",
  "events.story.rowLifecycle": "Stav životního cyklu",
  "events.story.rowLifecycleMeta": "Událost může postupovat dál bez ztráty kontextu pro operátory i auditory.",
  "events.story.rowOperations": "Provozní návaznosti",
  "events.story.rowOperationsMeta": "Reporting, editace i aktivita registrací zůstávají navázané na stejný záznam události.",
  "nav.tasks": "Moje úlohy",
  "nav.reviewQueue": "Fronta k hodnocení",
  "attendee.tasks.title": "Moje úlohy",
  "attendee.tasks.empty": "K této přihlášce zatím nejsou přiřazené žádné úlohy.",
  "attendee.tasks.emptyBody": "Pokud organizátor přidá test, dokument nebo formulář, zobrazí se zde spolu se stavem odevzdání.",
  "attendee.tasks.pickEnrollment": "Zvolte přihlášku, abyste viděli její úlohy.",
  "attendee.tasks.help.label": "Nápověda k výběru přihlášky",
  "attendee.tasks.help.body": "Úlohy se vážou ke konkrétní přihlášce. Pokud jste na více akcích, vyberte nejdříve správnou akci.",
  "attendee.tasks.kind.test": "Test",
  "attendee.tasks.kind.document": "Dokument",
  "attendee.tasks.kind.form": "Formulář",
  "attendee.tasks.required": "Povinné",
  "attendee.tasks.optional": "Nepovinné",
  "attendee.tasks.openDetail": "Otevřít úlohu",
  "attendee.tasks.backToList": "Zpět na moje úlohy",
  "attendee.tasks.status.not_started": "Nezapočato",
  "attendee.tasks.status.in_progress": "Rozpracováno",
  "attendee.tasks.status.submitted": "Odesláno",
  "attendee.tasks.status.returned": "Vráceno k přepracování",
  "attendee.tasks.status.accepted": "Přijato",
  "attendee.tasks.status.rejected": "Zamítnuto",
  "attendee.tasks.notes": "Poznámka pro reviewera",
  "attendee.tasks.saveDraft": "Uložit rozpracované",
  "attendee.tasks.submit": "Odeslat",
  "attendee.tasks.saved": "Změny uloženy.",
  "attendee.tasks.submitted": "Odesláno k hodnocení.",
  "attendee.tasks.testIntro": "Odpovězte na všechny povinné otázky. Před odesláním můžete uložit koncept.",
  "attendee.tasks.formIntro": "Pole označená hvězdičkou jsou povinná.",
  "attendee.tasks.documentIntro": "Nahrajte hotový dokument. Soubory před předáním hodnotiteli procházejí antivirovou kontrolou.",
  "attendee.tasks.uploads.title": "Přílohy",
  "attendee.tasks.uploads.empty": "Zatím nejsou nahrány žádné soubory.",
  "attendee.tasks.uploads.addFile": "Přidat soubor",
  "attendee.tasks.uploads.remove": "Odebrat",
  "attendee.tasks.uploads.pending": "Probíhá kontrola…",
  "attendee.tasks.uploads.clean": "Čisté",
  "attendee.tasks.uploads.infected": "Zablokováno (malware)",
  "attendee.tasks.uploads.error": "Chyba kontroly",
  "attendee.tasks.uploads.failed": "Kontrola selhala",
  "attendee.tasks.uploads.unavailable": "Antivir není dostupný",
  "attendee.tasks.uploads.bypassed": "Kontrola byla obejita",
  "attendee.tasks.uploads.quarantined": "Karanténa",
  "attendee.tasks.uploads.failureClass.configuration": "Konfigurace antivirové kontroly není úplná.",
  "attendee.tasks.uploads.failureClass.scanner_unavailable": "Antivirová kontrola je momentálně nedostupná.",
  "attendee.tasks.uploads.failureClass.transport": "Antivirová kontrola soubor nezpracovala.",
  "attendee.tasks.uploads.failureClass.unexpected": "Výsledek kontroly je nejednoznačný.",
  "attendee.tasks.uploads.retryability.retryable": "Po obnovení antiviru lze kontrolu zopakovat.",
  "attendee.tasks.uploads.retryability.not_retryable": "Opakování pravděpodobně nepomůže.",
  "attendee.tasks.uploads.retryability.unknown": "Zatím není jasné, zda opakování pomůže.",
  "attendee.tasks.decisionReason": "Poznámka hodnotitele",
  "attendee.tasks.returnReason": "Poznámka k přepracování",
  "reviewer.queue.title": "Fronta k hodnocení",
  "reviewer.queue.empty": "Žádné odeslané úlohy čekající na hodnocení.",
  "reviewer.queue.eventFilter": "Událost",
  "reviewer.queue.eventFilterAll": "Všechny události",
  "reviewer.queue.status.submitted": "Odesláno",
  "reviewer.queue.status.returned": "Vráceno",
  "reviewer.queue.openDetail": "Otevřít",
  "reviewer.submission.title": "Hodnocení odevzdání",
  "reviewer.submission.backToQueue": "Zpět do fronty",
  "reviewer.submission.participant": "Účastník",
  "reviewer.submission.content": "Obsah odevzdání",
  "reviewer.submission.uploads": "Přílohy",
  "reviewer.submission.history": "Historie rozhodnutí",
  "reviewer.submission.decision.accept": "Přijmout",
  "reviewer.submission.decision.reject": "Zamítnout",
  "reviewer.submission.decision.return": "Vrátit k přepracování",
  "reviewer.submission.decision.comment": "Přidat komentář",
  "reviewer.submission.comment": "Komentář viditelný pro účastníka",
  "reviewer.submission.reason": "Důvod rozhodnutí (povinné u přijetí/zamítnutí/vrácení)",
  "reviewer.submission.score": "Skóre",
  "reviewer.submission.scoreMax": "Maximum",
  "reviewer.submission.recorded": "Rozhodnutí zaznamenáno.",
  "reviewer.submission.action": "Rozhodnutí",
  "reviewer.submission.reasonRequired": "Uveďte prosím důvod tohoto rozhodnutí.",
  "reviewer.submission.noContent": "Účastník dosud neodeslal žádný obsah.",
  "reviewer.submission.scanEngine": "Scanner",
  "reviewer.submission.scanFailure": "Třída selhání",
  "reviewer.submission.scanRetryability": "Možnost opakování",
  "tasks.kind.self_presentation_video": "Sebeprezentační video",
  "tasks.kind.candidate_contact_list": "Seznam kontaktů na kandidáty",
  "tasks.kind.meeting_report": "Zápis ze schůzky",
  "tasks.readiness.storage.local_baseline": "Pilotní úložiště",
  "tasks.readiness.storage.storage_configured": "Cílové úložiště nastaveno",
  "tasks.readiness.storage.caveat.localBaseline": "Nahrané soubory jsou zatím uložené u aplikace. Pro pilot je to přijatelné, pro produkci je potřeba schválené cílové úložiště.",
  "tasks.readiness.scan.scan_mock": "Pilotní kontrola souborů",
  "tasks.readiness.scan.scan_configured": "Kontrola souborů nastavena",
  "tasks.readiness.scan.mode.mock": "Demo kontrola",
  "tasks.readiness.scan.mode.clamav_tcp": "ClamAV TCP",
  "tasks.readiness.scan.caveat.mock": "Toto prostředí používá demo kontrolu souborů. Tok je díky tomu testovatelný, ale pro produkci je potřeba schválená antivirová kontrola.",
  "tasks.readiness.kind.self_presentation_video": "Nahrávání videí zůstává blokované, dokud nebude formálně rozhodnuté cílové úložiště, antivirová cesta, retence a právní titul.",
  "tasks.readiness.kind.candidate_contact_list": "Nahrávání seznamu kontaktů na kandidáty zůstává blokované, dokud nebude formálně schválený právní titul, retence a řízené uložení.",
  "tasks.readiness.kind.meeting_report": "Nahrávání zápisu ze schůzky zůstává blokované, dokud nebude formálně rozhodnutý povolený formát, retence a právní/ochranný základ.",
  "admin.tasks.readiness.title": "Připravenost příloh úloh",
  "admin.tasks.readiness.intro": "Tato část ukazuje, zda je možné bezpečně přijímat přílohy k úlohám a proč některé citlivé typy úloh zatím zůstávají blokované.",
  "admin.tasks.readiness.storage": "Úložiště",
  "admin.tasks.readiness.scanning": "Kontrola souborů",
  "admin.tasks.readiness.storageSafety": "Produkční bezpečnost",
  "admin.tasks.readiness.productionSafe": "Produkčně použitelné",
  "admin.tasks.readiness.notProductionSafe": "Pouze pro pilot",
  "admin.tasks.readiness.blockedKinds": "Blokované typy úloh",
  "admin.tasks.readiness.enabledKinds": "{count} povolené typy",
  "admin.tasks.readiness.blockers": "Blokující otázky",
  "admin.tasks.readiness.requiredCapabilities": "Ještě chybí",
  "admin.tasks.readiness.capability.object_storage": "objektové úložiště",
  "admin.tasks.readiness.capability.antimalware": "antimalware",
  "admin.tasks.readiness.capability.legal_basis": "právní titul",
  "admin.tasks.readiness.capability.retention_policy": "retenční politika",
  "notFound.title": "Stránka nebyla nalezena",
  "notFound.body": "Požadovaná adresa neexistuje nebo byla přesunuta.",
  "notFound.home": "Zpět na úvod",
  "scanner.title": "Skener organizátora",
  "scanner.intro": "Skenujte QR kódy účastníků nebo zadávejte tokeny ručně. Offline skeny se frontí a po obnovení spojení se automaticky doručí.",
  "scanner.status.online": "Online",
  "scanner.status.offline": "Offline – frontí se",
  "scanner.eventLabel": "Událost",
  "scanner.selectEvent": "Vyberte událost…",
  "scanner.modeLabel": "Způsob zadání",
  "scanner.mode.token": "QR / token",
  "scanner.mode.enrollment": "ID přihlášky",
  "scanner.tokenLabel": "Obsah tokenu",
  "scanner.tokenPlaceholder": "Vložte naskenovaný token…",
  "scanner.camera.open": "Skenovat QR",
  "scanner.camera.cancel": "Zrušit skenování",
  "scanner.camera.retry": "Zkusit znovu",
  "scanner.camera.title": "Skenování kamerou",
  "scanner.camera.body": "Naměřte zadní kameru na QR kód účastníka. Po úspěšném skenu se token doplní automaticky.",
  "scanner.camera.launchTitle": "Nejprve zkuste kameru",
  "scanner.camera.launchBody": "Na telefonu je skenování kamerou nejrychlejší cesta, jak zachytit QR token účastníka.",
  "scanner.camera.manualTitle": "Ruční záloha",
  "scanner.camera.manualFallback": "Když kamera není dostupná, zavřete ji a použijte ruční zadání.",
  "scanner.camera.viewportHint": "Vycentrujte QR kód účastníka do rámečku.",
  "scanner.camera.flash.success": "QR zachycen. Pro dokončení docházkové akce potvrďte příchod nebo odchod.",
  "scanner.camera.flash.cancelled": "Skenování kamerou je zavřené. Token můžete vložit ručně níže.",
  "scanner.camera.status.starting": "Spouštím kameru…",
  "scanner.camera.status.ready": "Kamera připravená",
  "scanner.camera.status.permission_denied": "Přístup ke kameře byl zamítnut",
  "scanner.camera.status.unavailable": "Kamera není dostupná",
  "scanner.camera.status.unsupported": "Skenování kamerou tu není podporované",
  "scanner.camera.status.invalid": "Zachycený QR kód není použitelný",
  "scanner.enrollmentLabel": "ID přihlášky",
  "scanner.enrollmentPlaceholder": "např. 8c33…",
  "scanner.submit.checkIn": "Zapsat příchod",
  "scanner.submit.checkOut": "Zapsat odchod",
  "scanner.flash.recorded": "Příchod zaznamenán.",
  "scanner.flash.checkOutRecorded": "Odchod zaznamenán.",
  "scanner.flash.queued": "Jste offline – sken byl zařazen do fronty.",
  "scanner.story.kicker": "Sběr na místě",
  "scanner.story.title": "Rychlý check-in, odolný i offline",
  "scanner.story.body": "Stav fronty, kontext události i zpětná vazba operátorovi zůstávají viditelné i pod tlakem.",
  "scanner.story.metricQueue": "Čekající položky ke synchronizaci",
  "scanner.story.metricMode": "Aktivní režim vstupu",
  "scanner.story.metricEvent": "Vybraná událost",
  "scanner.story.rowCapture": "Zachytit a potvrdit",
  "scanner.story.rowCaptureMeta": "Okamžitá zpětná vazba po check-inu drží frontu v pohybu.",
  "scanner.story.rowResilience": "Offline odolnost",
  "scanner.story.rowResilienceMeta": "Frontované skeny se přehrávají se stejným auditovatelným klientským odkazem.",
  "scanner.kind.token": "Token",
  "scanner.kind.enrollment": "Přihláška",
  "scanner.errors.noEvent": "Nejprve vyberte událost.",
  "scanner.errors.noToken": "Nejprve naskenujte nebo vložte token.",
  "scanner.errors.noEnrollment": "Nejprve zadejte ID přihlášky.",
  "scanner.errors.duplicate_scan": "Zjištěn duplicitní sken – ignoruji.",
  "scanner.errors.enrollment_cancelled": "Tato přihláška byla zrušena.",
  "scanner.errors.enrollment_wrong_event": "Token nepatří k této události.",
  "scanner.errors.invalid_event_state": "Tato událost momentálně nepřijímá příchody.",
  "scanner.errors.unknown_enrollment": "Přihláška s daným ID nebyla nalezena.",
  "scanner.errors.attendance_token_malformed": "Token není platný.",
  "scanner.errors.attendance_token_bad_signature": "Podpis tokenu je neplatný.",
  "scanner.errors.attendance_token_expired": "Platnost tokenu vypršela.",
  "scanner.errors.attendance_token_revoked": "Token byl zneplatněn.",
  "scanner.errors.attendance_token_unknown_jti": "Token není rozpoznán.",
  "scanner.errors.attendance_token_tenant_mismatch": "Token patří jinému tenantovi.",
  "scanner.errors.attendance_token_event_mismatch": "Token neodpovídá této události.",
  "scanner.errors.attendance_token_enrollment_mismatch": "Token neodpovídá žádné přihlášce.",
  "scanner.queue.title": "Offline fronta",
  "scanner.queue.empty": "Fronta je prázdná.",
  "scanner.queue.syncNow": "Synchronizovat",
  "scanner.queue.syncing": "Synchronizuji…",
  "scanner.queue.clearSynced": "Odebrat odeslané",
  "scanner.queue.columns.label": "Sken",
  "scanner.queue.columns.status": "Stav",
  "scanner.queue.columns.attempts": "Pokusů",
  "scanner.queue.columns.error": "Poslední chyba",
  "scanner.queue.columns.actions": "Akce",
  "scanner.queue.status.pending": "Čeká",
  "scanner.queue.status.inflight": "Odesílá se",
  "scanner.queue.status.synced": "Odesláno",
  "scanner.queue.status.failed": "Selhalo",
  "nav.notifications": "Notifikace",
  "platform.title": "Platformní administrace",
  "platform.intro": "Oddělená plocha pro správu organizací a základních provozních stavů platformy.",
  "platform.story.kicker": "Platformní přehled",
  "platform.story.title": "Správa organizací bez míchání rolí",
  "platform.story.body": "Správce platformy vidí organizace, jazyky a provozní stav bez vstupu do běžné správy akcí.",
  "platform.story.metricHealth": "Aktivní organizace",
  "platform.story.metricLocales": "Podporované jazyky",
  "platform.story.rowRegistry": "Přehled organizací",
  "platform.story.rowRegistryMeta": "Platformní operátor rychle uvidí aktuální rozsah zapojených organizací.",
  "platform.story.rowGovernance": "Provozní správa",
  "platform.story.rowGovernanceMeta": "Změny stavu zůstávají explicitní a oddělené od administrace akcí.",
  "platform.summary.total": "Organizace celkem",
  "platform.summary.active": "Aktivní",
  "platform.summary.suspended": "Pozastavení",
  "platform.summary.archived": "Archivovaní",
  "platform.tenants.title": "Přehled organizací",
  "platform.tenants.intro": "Základní parametry organizací relevantní pro provoz platformy.",
  "platform.create.title": "Nová organizace",
  "platform.create.intro": "Vytvoří základní záznam organizace. Detailní onboarding může zůstat samostatným provozním krokem.",
  "platform.create.submit": "Vytvořit organizaci",
  "platform.create.localeMismatch": "Výchozí jazyk musí být součástí povolených jazyků.",
  "platform.field.code": "Kód",
  "platform.field.displayName": "Název",
  "platform.field.status": "Stav",
  "platform.field.defaultLocale": "Výchozí jazyk",
  "platform.field.allowedLocales": "Povolené jazyky",
  "platform.field.createdAt": "Vytvořeno",
  "platform.field.updatedAt": "Aktualizováno",
  "platform.status.active": "Aktivní",
  "platform.status.suspended": "Pozastavený",
  "platform.status.archived": "Archivovaný",
  "platform.cta.detail": "Detail",
  "platform.back": "Zpět na přehled organizací",
  "platform.detail.intro": "Základní metadata organizace a provozní stav.",
  "platform.detail.storyTitle": "Správa organizace zůstává explicitní",
  "platform.detail.storyBody": "Identita, jazykové nastavení i provozní stav zůstávají viditelné bez míchání do běžných akcí.",
  "platform.detail.metricLocale": "Primární jazyk",
  "platform.detail.metricLocales": "Povolená sada jazyků",
  "platform.detail.metricStatus": "Stav v registru",
  "platform.detail.rowRegistry": "Záznam organizace",
  "platform.detail.rowRegistryMeta": "Datum vzniku i kódy zůstávají čitelné pro platformní operátory.",
  "platform.detail.rowOperations": "Provozní stav",
  "platform.detail.rowOperationsMeta": "Změny stavu zůstávají auditovatelné a záměrně omezené rozsahem.",
  "platform.detail.statusTitle": "Provozní stav",
  "platform.detail.statusBody": "Změna stavu zde upravuje pouze základní záznam organizace. Detailní onboarding a offboarding může zůstat samostatným provozním krokem.",
  "platform.action.active": "Aktivovat",
  "platform.action.suspended": "Pozastavit",
  "platform.action.archived": "Archivovat",
  "admin.notifications.title": "Notifikace",
  "admin.notifications.intro": "Katalog šablon, zařazené notifikace a protokol o doručeních. Pouze pro čtení — editace šablon a cílené vyhledávání přijde v další vlně.",
  "admin.notifications.tabs.templates": "Šablony",
  "admin.notifications.tabs.jobs": "Zařazené",
  "admin.notifications.tabs.deliveries": "Doručení",
  "admin.notifications.templates.empty": "Žádné notifikační šablony nejsou zatím vytvořeny.",
  "admin.notifications.templates.code": "Kód",
  "admin.notifications.templates.channel": "Kanál",
  "admin.notifications.templates.locale": "Jazyk",
  "admin.notifications.templates.enabled": "Aktivní",
  "admin.notifications.templates.enabledYes": "Ano",
  "admin.notifications.templates.enabledNo": "Ne",
  "admin.notifications.templates.subject": "Předmět",
  "admin.notifications.templates.requiredVariables": "Povinné proměnné",
  "admin.notifications.jobs.empty": "Zatím žádné zařazené notifikace.",
  "admin.notifications.jobs.created": "Vytvořeno",
  "admin.notifications.jobs.trigger": "Spouštěč",
  "admin.notifications.jobs.template": "Šablona",
  "admin.notifications.jobs.recipient": "Příjemce",
  "admin.notifications.jobs.status": "Stav",
  "admin.notifications.jobs.attempts": "Pokusů",
  "admin.notifications.jobs.error": "Poslední chyba",
  "admin.notifications.jobs.state.pending": "Čeká",
  "admin.notifications.jobs.state.queued": "Zařazeno",
  "admin.notifications.jobs.state.sent": "Odesláno",
  "admin.notifications.jobs.state.failed": "Selhalo",
  "admin.notifications.jobs.state.cancelled": "Zrušeno",
  "admin.notifications.deliveries.empty": "Zatím nebyly zaznamenány žádné pokusy o doručení.",
  "admin.notifications.deliveries.startedAt": "Začátek",
  "admin.notifications.deliveries.channel": "Kanál",
  "admin.notifications.deliveries.transport": "Transport",
  "admin.notifications.deliveries.status": "Stav",
  "admin.notifications.deliveries.attempt": "Pokus",
  "admin.notifications.deliveries.error": "Chyba",
  "admin.notifications.deliveries.state.pending": "Čeká",
  "admin.notifications.deliveries.state.sent": "Odesláno",
  "admin.notifications.deliveries.state.failed": "Selhalo",
  "admin.identity.title": "Identity a mapování rolí",
  "admin.identity.intro": "Provozní baseline pro externí adresář: mapujte příchozí skupiny adresáře na aplikační role a kontrolujte výsledný efektivní přístup uživatelů.",
  "admin.identity.authMode": "Režim bearer autentizace",
  "admin.identity.posture": "Autentizační postoj",
  "admin.identity.authMode.mock_oidc": "Mock OIDC",
  "admin.identity.authMode.external_oidc": "Externí OIDC",
  "admin.identity.readiness.title": "Připravenost postoje",
  "admin.identity.readiness.intro": "Ukazuje aktuální runtime postoj a identity seams připravené k napojení, aniž by se předstíralo, že finální Entra business rozhodnutí už jsou uzavřená.",
  "admin.identity.readiness.browserLogin": "Browser login",
  "admin.identity.readiness.devBypass": "Dev bypass",
  "admin.identity.readiness.groupMappings": "Mapování skupin",
  "admin.identity.readiness.groupMappingsCount": "{count} nakonfigurováno",
  "admin.identity.readiness.state.ready": "Připraveno",
  "admin.identity.readiness.state.missing": "Chybí",
  "admin.identity.readiness.state.enabled": "Zapnuto",
  "admin.identity.readiness.state.disabled": "Vypnuto",
  "admin.identity.readiness.claimMappings": "Mapování claimů: {claims}",
  "admin.identity.readiness.requiredClaims": "Povinné claimy: {claims}",
  "admin.identity.readiness.none": "žádné",
  "admin.identity.readiness.productionSafe": "Toto prostředí splňuje kontrakt produkčně bezpečného autentizačního postoje, ale reálné ověření proti Entře i finální business mapování zůstávají mimo repozitář.",
  "admin.identity.readiness.notProductionSafe": "Toto prostředí je záměrně stále lokální, pilotní nebo nekompletní. Pro zkoušky je to v pořádku, ale není to důkaz uzavření go-live identity gateů.",
  "admin.identity.mappings.title": "Mapování skupin adresáře",
  "admin.identity.mappings.intro": "Mapování zůstává tenant-scoped a explicitní. Konkrétní názvy AD / Entra skupin patří sem, ne do business modulů.",
  "admin.identity.mappings.empty": "Zatím není definované žádné mapování skupin adresáře.",
  "admin.identity.mappings.directoryGroup": "Skupina adresáře",
  "admin.identity.mappings.role": "Role",
  "admin.identity.mappings.enabled": "Aktivní",
  "admin.identity.mappings.enabledYes": "Ano",
  "admin.identity.mappings.enabledNo": "Ne",
  "admin.identity.mappings.updatedAt": "Aktualizováno",
  "admin.identity.mappings.actions": "Akce",
  "admin.identity.form.directoryGroupCode": "Kód skupiny adresáře",
  "admin.identity.form.directoryGroupPlaceholder": "entra:event-admins",
  "admin.identity.form.role": "Aplikační role",
  "admin.identity.form.enabled": "Mapování je aktivní",
  "admin.identity.flash.created": "Mapování skupiny adresáře bylo vytvořeno.",
  "admin.identity.flash.updated": "Mapování skupiny adresáře bylo aktualizováno.",
  "admin.identity.access.title": "Efektivní přístup",
  "admin.identity.access.intro": "Zobrazuje poslední známý snapshot skupin adresáře pro každého uživatele a výsledné aplikační role odvozené z mapování a manuálních přiřazení.",
  "admin.identity.access.empty": "Zatím nejsou k dispozici žádné identity.",
  "admin.identity.access.user": "Uživatel",
  "admin.identity.access.subject": "Externí subject",
  "admin.identity.access.groups": "Skupiny adresáře",
  "admin.identity.access.effectiveRoles": "Efektivní role",
  "admin.identity.access.attributes": "Atributy adresáře",
  "admin.identity.access.status.active": "Aktivní",
  "admin.identity.access.status.disabled": "Zakázaný",
  "admin.identity.access.status.pending": "Čekající",
  "admin.identity.access.source.manual_assignment": "Manuální přiřazení ({value})",
  "admin.identity.access.source.directory_group": "Skupina adresáře {value}",
  "admin.identity.access.source.platform_directory_group": "Platformní skupina adresáře {value}",
  "admin.identity.access.source.mock_role_claim": "Mock role claim {value}",
  "admin.identity.access.source.dev_bypass": "Vývojové obejití ({value})",
  "admin.identity.access.scope.platform": "Platforma",
  "admin.identity.access.scope.tenant": "Tenant",
  "admin.identity.readiness.platformAdminGroups": "Skupiny pro platform_admin",
  "admin.identity.readiness.platformAdminGroups.configured": "Nakonfigurováno",
  "admin.identity.readiness.platformAdminGroups.missing": "Nenastaveno",
  "admin.identity.mappings.platformConflict.title": "Konflikt vyhrazených platformních skupin",
  "admin.identity.mappings.platformConflict": "Skupina adresáře \"{group}\" je vyhrazena pro platformní rozlišení admin. Tento tenantní záznam je třeba odstranit.",
  "session.workspace.platform": "Platformní operace",
  "session.workspace.admin": "Tenant admin",
  "session.workspace.attendee": "Moje přihlášky",
  "me.accessDiagnostics.title": "Můj efektivní přístup",
  "me.accessDiagnostics.scopePlatform": "Platformní role",
  "me.accessDiagnostics.scopeTenant": "Role v tenantu",
  "me.accessDiagnostics.scopeNone": "Žádné role nebyly zjištěny",
  "admin.identity.attributes.manager": "Nadřízený",
  "admin.identity.attributes.position": "Pozice",
  "admin.identity.attributes.level": "Úroveň",
  "admin.identity.attributes.employmentStatus": "Pracovní status",
  "admin.identity.attributes.licenses": "Licence",
  "nav.reporting": "Reporting",
  "reporting.title": "Reporting události",
  "reporting.intro": "Přehled po účastnících nad aktuálně známými daty z přihlášek, docházky a úloh. Report ukazuje dostupné signály bez toho, aby předjímal finální HR rozhodnutí.",
  "reporting.index.title": "Reporting",
  "reporting.index.intro": "Vyberte událost, pro kterou chcete zobrazit přehled účastníků a exporty.",
  "reporting.index.empty": "Zatím nejsou k dispozici žádné události pro reporting.",
  "reporting.index.emptyBody": "Report se zobrazí po vytvoření a publikaci události. Jakmile se začnou plnit přihlášky, docházka nebo úkoly, budou zde dostupné pro kontrolu.",
  "reporting.index.columnCode": "Kód",
  "reporting.index.columnTitle": "Název",
  "reporting.index.columnState": "Stav",
  "reporting.index.columnStartsAt": "Začátek",
  "reporting.index.open": "Otevřít report",
  "reporting.openEvent": "Otevřít report",
  "reporting.empty": "Pro tuto událost zatím nejsou žádní účastníci.",
  "reporting.generatedAt": "Generováno",
  "reporting.summary.title": "Souhrn",
  "reporting.summary.enrollment": "Přihlášky",
  "reporting.summary.attendance": "Docházka",
  "reporting.summary.tasks": "Úlohy",
  "reporting.summary.completion": "Completion",
  "reporting.summary.total": "Celkem: {count}",
  "reporting.warnings.title": "Důležité poznámky",
  "reporting.eventMeta.title": "Metadata reportu",
  "reporting.matrix.title": "Matice účastníků",
  "reporting.conditions.title": "Deklarované podmínky události",
  "reporting.condition.kind.entry": "Vstupní podmínka",
  "reporting.condition.kind.exit": "Výstupní podmínka",
  "reporting.condition.evaluation.deferred": "Vyhodnocení této podmínky je v baseline odloženo",
  "reporting.column.participant": "Účastník",
  "reporting.column.role": "Role v události",
  "reporting.column.enrollment": "Přihláška",
  "reporting.column.attendance": "Docházka",
  "reporting.column.tasks": "Úlohy",
  "reporting.column.completion": "Completion",
  "reporting.role.custom": "Vlastní role",
  "reporting.warning.attendancePolicyConfigurable": "Docházka se vyhodnocuje podle aktuální konfigurovatelné baseline politiky. Finální business a HR význam je možné dál zpřesňovat po tenantovi nebo typu události.",
  "reporting.warning.attendancePolicyDefaultFallback": "Tato událost používá systémovou výchozí docházkovou politiku, protože zatím není nastavené pravidlo na typu ani na konkrétní instanci.",
  "reporting.warning.attendancePolicyLegacyFallback": "Tato událost stále používá migrované legacy prahy docházky. Pro přehlednější správu U-06 ji převeďte na explicitní docházkovou politiku.",
  "reporting.warning.completionBlocked": "Completion zůstává blokovaný tam, kde jsou ještě odložené úlohy nebo policy otázky. Report tyto blokace ukazuje explicitně a nepředstírá finální verdict.",
  "reporting.warning.completionPolicyBaseline": "Completion ukazuje aktuální baseline příspěvek z docházky a úloh. Je přesnější než dříve, ale stále nejde o finální právní nebo HR verdict.",
  "reporting.enrollment.registered": "Registrován",
  "reporting.enrollment.waitlisted": "Čekací listina",
  "reporting.enrollment.cancelled": "Zrušeno",
  "reporting.attendance.policyMet": "Vyhovuje baseline docházkové politice",
  "reporting.attendance.withinPolicyExceptions": "Vyhovuje v rámci povolených výjimek",
  "reporting.attendance.policyNotMet": "Nevyhovuje baseline docházkové politice",
  "reporting.attendance.notApplicableWaitlisted": "Docházka se zatím nehodnotí (čekací listina)",
  "reporting.attendance.notApplicableCancelled": "Docházka se nehodnotí (zrušená přihláška)",
  "reporting.tasks.blockedAssignments": "Obsahuje blokované úlohy",
  "reporting.tasks.noActiveTasks": "Bez aktivních úloh",
  "reporting.tasks.attentionRequired": "Vyžaduje zásah reviewera nebo účastníka",
  "reporting.tasks.allRequiredAccepted": "Všechny povinné úlohy přijaty",
  "reporting.tasks.reviewPending": "Čeká na review / dokončení",
  "reporting.tasks.inProgress": "Rozpracované",
  "reporting.tasks.notStarted": "Nezahájeno",
  "reporting.tasks.note.blockedAssignments": "Událost obsahuje úlohy, které jsou v této vlně architektonicky evidované, ale nadále blokované z důvodu otevřených privacy/policy otázek.",
  "reporting.tasks.requiredAcceptedSummary": "Povinné přijato: {accepted}/{total}",
  "reporting.completion.notApplicableWaitlisted": "Completion se zatím nehodnotí (čekací listina)",
  "reporting.completion.notApplicableCancelled": "Completion se nehodnotí (zrušená přihláška)",
  "reporting.completion.blockedByDeferredTasks": "Completion blokují odložené úlohy/politiky",
  "reporting.completion.baselineRequirementsMet": "Baseline požadavky splněny",
  "reporting.completion.attendancePolicyNotMet": "Docházková baseline politika není splněna",
  "reporting.completion.requirementsOutstanding": "Stále zbývají nesplněné nebo neuzavřené signály",
  "reporting.note.late_arrival": "Pozdní příchod",
  "reporting.note.early_departure": "Předčasný odchod",
  "reporting.note.partial_presence": "Částečná přítomnost",
  "reporting.note.allowed_absence_used": "Využitá povolená absence",
  "reporting.note.attendance_policy_not_met": "Docházková baseline politika není splněna",
  "reporting.note.attendance_policy_schedule_fallback": "Politika se přepnula na vyhodnocení celé události, protože chybí rozpis jednotlivých bloků.",
  "reporting.note.attendance_policy_default_unit_fallback": "Politika se přepnula na vyhodnocení celé události, protože nebyly dostupné žádné denní ani blokové jednotky.",
  "reporting.export.csv": "Export CSV",
  "reporting.export.pdf": "Export PDF",
  "reporting.export.downloading": "Generuji…",
  "reporting.export.failed": "Export se nepodařil",
  "reporting.attendancePolicy.title": "Docházková politika",
  "reporting.attendancePolicy.intro": "Tento report ukazuje efektivní baseline docházkovou politiku použitou pro vyhodnocení a exportní semantiku.",
  "reporting.attendancePolicy.source": "Zdroj politiky",
  "reporting.attendancePolicy.sourceValue.event_instance": "Přepis na instanci události",
  "reporting.attendancePolicy.sourceValue.event_type": "Baseline typu události",
  "reporting.attendancePolicy.sourceValue.legacy_rules": "Fallback na legacy prahy",
  "reporting.attendancePolicy.sourceValue.default": "Systémový výchozí stav",
  "reporting.attendancePolicy.unitMode": "Vyhodnocovací jednotka",
  "reporting.attendancePolicy.unitModeValue.whole_event": "Celá událost",
  "reporting.attendancePolicy.unitModeValue.event_day": "Po dnech události",
  "reporting.attendancePolicy.unitModeValue.schedule_item": "Po plánovaných blocích",
  "reporting.attendancePolicy.allowedAbsenceUnits": "Povolené absence",
  "reporting.attendancePolicy.minimumPresenceMinutes": "Minimální přítomnost (minuty)",
  "reporting.attendancePolicy.lateGraceMinutes": "Tolerance pozdního příchodu (minuty)",
  "reporting.attendancePolicy.earlyDepartureGraceMinutes": "Tolerance předčasného odchodu (minuty)",
  "reporting.edocation.title": "Předání do eDOcation",
  "reporting.edocation.intro": "Vygenerujte a zkontrolujte aktuální contract-ready artefakt pro předání docházky, který vlastní integrační modul.",
  "reporting.edocation.contractPending": "Skutečný transportní a potvrzovací kontrakt eDOcation je stále otevřený v U-10. Tato baseline zatím ukládá a odesílá pouze mock contract-ready payload.",
  "reporting.edocation.runtimeNote.mock_contract": "Skutečný kontrakt eDOcation je stále otevřený v U-10. Toto prostředí zůstává na poctivé mock, pouze ukládací cestě.",
  "reporting.edocation.runtimeNote.contract_ready": "HTTP kontraktní seam je připravený, ale toto prostředí zatím předání pouze ukládá bez živého přenosu, dokud se U-10 formálně neuzavře.",
  "reporting.edocation.runtimeNote.transport_configured": "Živý transport je zapnutý přes konfigurovatelný HTTP seam, ale externí kontrakt se až do formálního uzavření U-10 stále bere jako provizorní.",
  "reporting.edocation.trigger": "Vygenerovat předání",
  "reporting.edocation.triggering": "Generuji předání…",
  "reporting.edocation.empty": "Pro tuto událost zatím nebylo spuštěno žádné předání do eDOcation.",
  "reporting.edocation.requestedAt": "Vyžádáno",
  "reporting.edocation.requestedBy": "Spustil: {user}",
  "reporting.edocation.status": "Stav",
  "reporting.edocation.participants": "Účastníci",
  "reporting.edocation.participantCount": "{count} účastníků",
  "reporting.edocation.latestAttempt": "Poslední pokus",
  "reporting.edocation.summary": "Souhrn",
  "reporting.edocation.summaryPending": "Souhrn payloadu zatím není k dispozici.",
  "reporting.edocation.flash.sent": "Předání bylo zpracováno.",
  "reporting.edocation.flash.stored": "Předání bylo v aktuálním režimu pouze uložené.",
  "reporting.edocation.flash.transmitted": "Předání bylo odeslané do nakonfigurovaného transportu.",
  "reporting.edocation.flash.blocked": "Generování předání bylo zablokováno kvůli chybějícím povinným údajům o události nebo účastníkovi.",
  "reporting.edocation.flash.failed": "Předání selhalo až po vygenerování payloadu.",
  "reporting.edocation.statusValue.pending": "Čeká",
  "reporting.edocation.statusValue.generated": "Vygenerováno",
  "reporting.edocation.statusValue.sent": "Odesláno",
  "reporting.edocation.statusValue.awaiting_acknowledgment": "Čeká na potvrzení",
  "reporting.edocation.statusValue.acknowledged": "Potvrzeno",
  "reporting.edocation.statusValue.rejected": "Odmítnuto",
  "reporting.edocation.statusValue.failed": "Selhalo",
  "reporting.edocation.statusValue.blocked": "Blokováno",
  "reporting.edocation.attemptStatus.sent": "Odesláno",
  "reporting.edocation.attemptStatus.awaiting_acknowledgment": "Čeká na potvrzení",
  "reporting.edocation.attemptStatus.acknowledged": "Potvrzeno",
  "reporting.edocation.attemptStatus.rejected": "Odmítnuto",
  "reporting.edocation.attemptStatus.failed": "Selhalo",
  "reporting.edocation.attemptStatus.blocked": "Blokováno",
  "reporting.edocation.latestAttempt.none": "Zatím není zaznamenaný žádný pokus o doručení.",
  "reporting.edocation.adapter.mock_contract": "Mock contract-ready adaptér",
  "reporting.edocation.adapter.http_contract": "Konfigurovatelný HTTP kontraktní adaptér",
  "reporting.edocation.contractStatus.pending_u10": "Kontrakt čeká na finální U-10 detaily rozhraní",
  "reporting.edocation.contractStatus.decision_ready": "Kontrakt je připravený pro rozhodnutí",
  "reporting.edocation.contractStatus.validated_u10": "Kontrakt je potvrzený po U-10",
  "reporting.edocation.posture.mock_contract": "Mock kontrakt",
  "reporting.edocation.posture.contract_ready": "Kontrakt připravený",
  "reporting.edocation.posture.transport_configured": "Transport je nakonfigurovaný",
  "reporting.edocation.deliveryMode.stored_only": "Pouze uložené",
  "reporting.edocation.deliveryMode.transmitted": "Skutečně přenesené",
  "reporting.edocation.transport.mock_payload_store": "Mock úložiště payloadů",
  "reporting.edocation.transport.http_json": "HTTP JSON transport",
  "reporting.edocation.auth.none": "Bez konfigurace autentizace",
  "reporting.edocation.auth.bearer_token": "Bearer token",
  "reporting.edocation.auth.static_header": "Statická hlavička",
  "reporting.edocation.ack.unsupported": "Potvrzení není podporované",
  "reporting.edocation.ack.none": "Potvrzení se neočekává",
  "reporting.edocation.ack.synchronous": "Synchronní potvrzení",
  "reporting.edocation.ack.asynchronous": "Asynchronní potvrzení",
  "reporting.edocation.diagnostics.posture": "Aktuální režim",
  "reporting.edocation.diagnostics.delivery": "Aktuální doručení",
  "reporting.edocation.diagnostics.readiness": "Připravenost",
  "reporting.edocation.diagnostics.endpoint": "Endpoint",
  "reporting.edocation.diagnostics.auth": "Autentizace",
  "reporting.edocation.diagnostics.ack": "Potvrzení",
  "reporting.edocation.diagnostics.transmission": "Přenos",
  "reporting.edocation.diagnostics.targetTransport": "Cílový transport",
  "reporting.edocation.transmission.active": "Aktivní",
  "reporting.edocation.transmission.inactive": "Pouze ukládání",
  "reporting.edocation.caveat.u10Open": "U-10 je stále otevřené: finální transport, autentizace, potvrzení a reklamační/reconciliační tok ještě nemají schválení.",
  "reporting.edocation.caveat.mockOnly": "Toto prostředí stále běží jen na mock kontraktu; žádné reálné upstream doručení není aktivní.",
  "reporting.edocation.caveat.storeOnly": "HTTP kontraktní seam je připravený, ale toto prostředí zatím předání pouze ukládá bez skutečného přenosu.",
  "reporting.edocation.caveat.provisionalTransport": "Živý přenos běží přes konfigurovatelný seam, ale finální externí kontrakt zůstává do uzavření U-10 pouze provizorní.",
  "reporting.edocation.failureClass.configuration": "Blokováno konfigurací integrace",
  "reporting.edocation.failureClass.contract_validation": "Blokováno validací payload kontraktu",
  "reporting.edocation.failureClass.transport": "Transportní selhání",
  "reporting.edocation.failureClass.remote_rejection": "Odmítnutí na vzdálené straně",
  "reporting.edocation.failureClass.unknown": "Neznámé integrační selhání",
  "reporting.story.kicker": "Jasnost rozhodování",
  "reporting.story.title": "Completion signály jsou snadno čitelné",
  "reporting.story.body": "Reporting i předání do eDOcation zůstávají explicitní, dohledatelné a prezentovatelně podané.",
  "reporting.story.metricAttendance": "Baseline pokrytí události",
  "reporting.story.metricCompletion": "Sada completion signálů",
  "reporting.story.metricHandoff": "Zaznamenaná předání",
  "reporting.story.rowEvaluation": "Vyhodnocovací pohled",
  "reporting.story.rowEvaluationMeta": "Docházka, úlohy i completion zůstávají viditelné vedle sebe.",
  "reporting.story.rowExport": "Připravenost exportu",
  "reporting.story.rowExportMeta": "CSV, PDF i handoff artefakty zůstávají blízko živé sadě signálů.",
  "reporting.pdf.eventCode": "Kód události",
  "reporting.pdf.eventType": "Typ události",
  "reporting.pdf.startsAt": "Začátek",
  "reporting.pdf.endsAt": "Konec",
  "reporting.pdf.generatedAt": "Generováno",
  "reporting.pdf.requestedBy": "Vyžádal",
  "reporting.pdf.summaryTitle": "Souhrn completion signálů",
  "reporting.pdf.conditionsTitle": "Deklarované podmínky",
  "reporting.pdf.participantsTitle": "Účastníci",
  "reporting.pdf.notes": "Poznámky",
  "attendance.policy.title": "Docházková politika",
  "attendance.policy.intro": "Tato událost dědí baseline docházkovou politiku z typu události, dokud nepřidáte přepis pro konkrétní instanci. Pravidlo zůstává konfigurovatelné, protože U-06 je stále businessová otázka.",
  "attendance.policy.source": "Zdroj politiky",
  "attendance.policy.sourceValue.event_instance": "Přepis na instanci události",
  "attendance.policy.sourceValue.event_type": "Baseline typu události",
  "attendance.policy.sourceValue.legacy_rules": "Fallback na legacy prahy",
  "attendance.policy.sourceValue.default": "Systémový výchozí stav",
  "attendance.policy.unitMode": "Vyhodnocovací jednotka",
  "attendance.policy.unitModeValue.whole_event": "Celá událost",
  "attendance.policy.unitModeValue.event_day": "Po dnech události",
  "attendance.policy.unitModeValue.schedule_item": "Po plánovaných blocích",
  "attendance.policy.allowedAbsenceUnits": "Povolené absence",
  "attendance.policy.minimumPresenceMinutes": "Minimální přítomnost (minuty)",
  "attendance.policy.lateGraceMinutes": "Tolerance pozdního příchodu (minuty)",
  "attendance.policy.earlyDepartureGraceMinutes": "Tolerance předčasného odchodu (minuty)",
  "attendance.policy.partialCountsAsAbsence": "Počítat částečnou přítomnost jako absenci",
  "attendance.policy.flash.saved": "Docházková politika byla uložena.",
  "attendance.policy.flash.removed": "Přepis docházkové politiky pro tuto událost byl odstraněn.",
  "attendance.policy.saving": "Ukládám…",
  "attendance.policy.save": "Uložit docházkovou politiku",
  "attendance.policy.resetToInherited": "Vrátit zděděnou politiku"
}
